import type { Result } from 'neverthrow';

import { apiRequest, type ApiError } from './client';

/**
 * Billing API client per ADR 0017. Two calls back Step 5's card
 * capture:
 *   - `createSetupIntent` — fetches a SetupIntent client_secret on
 *     mount; the Stripe Elements PaymentElement confirms it.
 *   - `finalizeBilling` — after the SetupIntent confirms, sends the
 *     captured PaymentMethod id; the backend attaches it as default
 *     and creates the trial Subscription.
 */

export interface SetupIntentResponse {
  readonly client_secret: string;
}

export interface FinalizeBillingResponse {
  readonly billing_status: 'trial' | 'active' | 'past_due' | 'cancelled' | 'unbilled';
  readonly trial_ends_at?: string;
}

export function createSetupIntent(): Promise<Result<SetupIntentResponse, ApiError>> {
  return apiRequest<SetupIntentResponse>({ method: 'POST', path: '/billing/setup-intent' });
}

export function finalizeBilling(
  paymentMethodId: string,
): Promise<Result<FinalizeBillingResponse, ApiError>> {
  return apiRequest<FinalizeBillingResponse>({
    method: 'POST',
    path: '/billing/finalize',
    body: { payment_method_id: paymentMethodId },
  });
}
